const navItemData = [
    {
    _id:1,
    name: "home",
    active: true
    },
    {
    _id:2,
    name: "schedule",
    active: false
    },
    {
    _id:3,
    name: "trend",
    active: false
    },
    {
    _id:4,
    name: "blog",
    active: false
    },
]
export default navItemData